var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_400",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29214",
    "data-name": "Group 29214",
    transform: "translate(138 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -138, -11197)",
    filter: "url(#Ellipse_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_400-2",
    "data-name": "Ellipse 400",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_7_",
    "data-name": "svgexport-17 (7)",
    transform: "translate(-115.174 -11178.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49974",
    "data-name": "Path 49974",
    d: "M55.5,341.7v-5.2h4.547v7.145h-2.6A1.949,1.949,0,0,1,55.5,341.7Z",
    transform: "translate(-54.85 -315.811)",
    fill: "#aa6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49975",
    "data-name": "Path 49975",
    d: "M58.748,343.645h-1.3A1.949,1.949,0,0,1,55.5,341.7v-5.2h1.3v5.2A1.949,1.949,0,0,0,58.748,343.645Z",
    transform: "translate(-54.85 -315.811)",
    fill: "#9e653b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49976",
    "data-name": "Path 49976",
    d: "M50.047,299.748h-3.9a.65.65,0,0,1-.65-.65v-1.3a1.3,1.3,0,0,1,1.3-1.3h3.248Z",
    transform: "translate(-45.5 -278.409)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49977",
    "data-name": "Path 49977",
    d: "M47.449,299.748h-1.3a.65.65,0,0,1-.65-.65v-1.3a1.3,1.3,0,0,1,1.3-1.3v2.6A.65.65,0,0,0,47.449,299.748ZM72.2,304.295v-5.2H67.651v7.145h2.6A1.949,1.949,0,0,0,72.2,304.295Z",
    transform: "translate(-45.5 -278.409)",
    fill: "#aa6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49978",
    "data-name": "Path 49978",
    d: "M396.5,299.748h3.9a.65.65,0,0,0,.65-.65v-1.3a1.3,1.3,0,0,0-1.3-1.3H396.5Z",
    transform: "translate(-373.7 -278.409)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49979",
    "data-name": "Path 49979",
    d: "M109.838,103.133H93.6a2.6,2.6,0,0,1-2.6-2.6V76.5h21.436v24.034A2.6,2.6,0,0,1,109.838,103.133Z",
    transform: "translate(-88.044 -72.7)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49980",
    "data-name": "Path 49980",
    d: "M112.436,196.49v.974a3.241,3.241,0,0,1-2.6,1.3H93.6a3.241,3.241,0,0,1-2.6-1.3v-.974a3.241,3.241,0,0,0,2.6,1.3h16.239a3.241,3.241,0,0,0,2.6-1.3Z",
    transform: "translate(-88.044 -184.896)",
    fill: "#d88646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49981",
    "data-name": "Path 49981",
    d: "M277.5,343.645H271.65A.65.65,0,0,1,271,343v-6.5h7.145V343A.65.65,0,0,1,277.5,343.645Z",
    transform: "translate(-256.352 -315.811)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49982",
    "data-name": "Path 49982",
    d: "M278.145,361.5v.974l-2.463.9a3.252,3.252,0,0,1-2.22,0l-2.463-.9V361.5l2.463.9a3.252,3.252,0,0,0,2.22,0Z",
    transform: "translate(-256.352 -339.187)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49983",
    "data-name": "Path 49983",
    d: "M278.145,329.1l-2.463.9a3.248,3.248,0,0,1-2.22,0L271,329.1V327.15a.65.65,0,0,1,.65-.65H277.5a.65.65,0,0,1,.65.65Z",
    transform: "translate(-256.352 -306.461)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 0.487,
    cy: 0.487,
    rx: 0.487,
    ry: 0.487,
    transform: "translate(17.733 21.91)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49984",
    "data-name": "Path 49984",
    d: "M137.5,343.645H131.65A.65.65,0,0,1,131,343v-6.5h7.145V343A.65.65,0,0,1,137.5,343.645Z",
    transform: "translate(-125.446 -315.811)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49985",
    "data-name": "Path 49985",
    d: "M138.145,361.5v.974l-2.463.9a3.252,3.252,0,0,1-2.22,0l-2.463-.9V361.5l2.463.9a3.252,3.252,0,0,0,2.22,0Z",
    transform: "translate(-125.446 -339.187)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49986",
    "data-name": "Path 49986",
    d: "M138.145,329.1l-2.463.9a3.248,3.248,0,0,1-2.22,0L131,329.1V327.15a.65.65,0,0,1,.65-.65H137.5a.65.65,0,0,1,.65.65Z",
    transform: "translate(-125.446 -306.461)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 0.487,
    cy: 0.487,
    rx: 0.487,
    ry: 0.487,
    transform: "translate(8.639 21.91)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49987",
    "data-name": "Path 49987",
    d: "M111.866,47.458a2.592,2.592,0,0,1-2.028.974H93.6a2.6,2.6,0,0,1-2.6-2.6V21.8h1.3V45.51a1.949,1.949,0,0,0,1.949,1.949Zm-7.225-23.937a.487.487,0,0,1-.487-.487V21.41a2.436,2.436,0,1,0-4.872,0v1.624a.487.487,0,0,1-.974,0V21.41a3.41,3.41,0,1,1,6.821,0v1.624A.487.487,0,0,1,104.641,23.521Z",
    transform: "translate(-88.044 -18)",
    fill: "#d88646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49988",
    "data-name": "Path 49988",
    d: "M100.487,76.244H84.248A3.248,3.248,0,0,1,81,73V67.15a.65.65,0,0,1,.65-.65h21.436a.65.65,0,0,1,.65.65V73A3.248,3.248,0,0,1,100.487,76.244Z",
    transform: "translate(-78.694 -63.35)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49989",
    "data-name": "Path 49989",
    d: "M85.547,76.244h-1.3A3.248,3.248,0,0,1,81,73V67.15a.65.65,0,0,1,.65-.65h.65V73a3.248,3.248,0,0,0,3.248,3.248Z",
    transform: "translate(-78.694 -63.35)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49990",
    "data-name": "Path 49990",
    d: "M327.3,71.44a1.3,1.3,0,0,1-1.3-1.3V57.15a.65.65,0,0,1,.65-.65h1.3a.65.65,0,0,1,.65.65V70.141A1.3,1.3,0,0,1,327.3,71.44Z",
    transform: "translate(-307.779 -53.999)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49991",
    "data-name": "Path 49991",
    d: "M317.235,187.9h-3.248a.487.487,0,0,1-.487-.487v-3.248a.487.487,0,0,1,.487-.487h3.248a.487.487,0,0,1,.487.487v3.248A.487.487,0,0,1,317.235,187.9Zm-2.761-.974h2.274v-2.273h-2.274Z",
    transform: "translate(-296.091 -172.916)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49992",
    "data-name": "Path 49992",
    d: "M338.987,216.6a.487.487,0,0,1-.487-.487v-1.949a.487.487,0,0,1,.974,0v1.949A.487.487,0,0,1,338.987,216.6Z",
    transform: "translate(-319.467 -200.967)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49993",
    "data-name": "Path 49993",
    d: "M147.3,71.44a1.3,1.3,0,0,1-1.3-1.3V57.15a.65.65,0,0,1,.65-.65h1.3a.65.65,0,0,1,.65.65V70.141A1.3,1.3,0,0,1,147.3,71.44Z",
    transform: "translate(-139.472 -53.999)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49994",
    "data-name": "Path 49994",
    d: "M137.235,187.9h-3.248a.487.487,0,0,1-.487-.487v-3.248a.487.487,0,0,1,.487-.487h3.248a.487.487,0,0,1,.487.487v3.248A.487.487,0,0,1,137.235,187.9Zm-2.761-.974h2.274v-2.273h-2.274Z",
    transform: "translate(-127.784 -172.916)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49995",
    "data-name": "Path 49995",
    d: "M158.987,216.6a.487.487,0,0,1-.487-.487v-1.949a.487.487,0,0,1,.974,0v1.949A.487.487,0,0,1,158.987,216.6Z",
    transform: "translate(-151.16 -200.967)",
    fill: "#ffb155"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/Backpack.97d53bb40ed709ec1f65ddd495121202.svg";
export { ForwardRef as ReactComponent };